import { render } from "./TemplateDataTable.vue?vue&type=template&id=0d09b935&scoped=true"
import script from "./TemplateDataTable.vue?vue&type=script&lang=ts"
export * from "./TemplateDataTable.vue?vue&type=script&lang=ts"

import "./TemplateDataTable.vue?vue&type=style&index=0&id=0d09b935&scoped=true&lang=scss"
import "./TemplateDataTable.vue?vue&type=style&index=1&id=0d09b935&lang=scss"
script.render = render
script.__scopeId = "data-v-0d09b935"

export default script